export default "__VITE_ASSET__Z04vOk9$__"